import {useQuery} from "@tanstack/react-query"
import {API} from "config"

const useSalesReport = () => useQuery({ queryKey: [`sales-report`], queryFn: async () => {
    const callback = await API.get(`/reports/sales_daily_growth?period=last_30_days`)
    return callback?.data
}, staleTime: 3000, gcTime: 1000 * 60 * 10 })

export default useSalesReport